// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  --box-shadow: none !important;
  box-shadow: 0px 4px 56px 0px rgba(0, 0, 0, 0.0705882353) !important;
}

ion-content {
  --padding-start: 16px;
  --padding-end: 16px;
  --padding-top: 16px;
  --padding-bottom: 16px;
  --background: var(--background-default);
}

.title {
  width: 100%;
  font-family: AppFontMedium;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: 0.02em;
  vertical-align: middle;
  text-align: center;
  text-transform: uppercase;
  color: var(--color-black);
  margin-bottom: 16px;
}

.wrapper {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  height: -moz-fit-content;
  height: fit-content;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(46%, 1fr));
  gap: 10px;
}
.wrapper .item {
  min-height: 165px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 14px 12px;
  border-radius: var(--radius-default);
  background: #ffffff;
  border: 1px solid #f6ebde;
  cursor: pointer;
  position: relative;
}
.wrapper .item ion-img,
.wrapper .item ion-icon {
  height: 90px;
  object-fit: contain;
  margin-bottom: 10px;
}
.wrapper .item ion-img.default,
.wrapper .item ion-icon.default {
  padding-inline: 16px;
  --icon-color: var(--color-black);
  height: 90px;
  width: 100%;
}
.wrapper .item .name {
  font-family: AppFontSemiBold;
  font-size: 14px;
  line-height: 100%;
  text-align: center;
  text-transform: uppercase;
  color: var(--ion-color-tertiary);
}
.wrapper .item .info {
  margin: 0;
  flex: 1;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: AppFontMedium;
  font-size: 12px;
  line-height: 110%;
  letter-spacing: 0;
  vertical-align: middle;
  color: var(--color-black);
  margin-top: 6px;
}

.spinner-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/select-category/select-category.page.scss"],"names":[],"mappings":"AAEA;EACC,6BAAA;EACA,mEAAA;AADD;;AAIA;EACC,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,uCAAA;AAFD;;AAaA;EACC,WAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,yBAAA;EACA,mBAAA;AAXD;;AAcA;EACC,WAAA;EACA,iBAAA;EACA,cAAA;EACA,wBAAA;EAAA,mBAAA;EAEA,aAAA;EACA,0DAAA;EACA,SAAA;AAZD;AAcC;EACC,iBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,yBAAA;EAEA,eAAA;EACA,kBAAA;AAdF;AAgBE;;EAEC,YAAA;EACA,mBAAA;EAEA,mBAAA;AAfH;AAiBG;;EACC,oBAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;AAdJ;AAkBE;EACC,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,gCAAA;AAjBH;AAoBE;EACC,SAAA;EACA,OAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EAEA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EAEA,yBAAA;EACA,eAAA;AApBH;;AAyBA;EACC,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAtBD","sourcesContent":["@use '../../../theme/mixins' as *;\n\nion-header {\n\t--box-shadow: none !important;\n\tbox-shadow: 0px 4px 56px 0px #00000012 !important;\n}\n\nion-content {\n\t--padding-start: 16px;\n\t--padding-end: 16px;\n\t--padding-top: 16px;\n\t--padding-bottom: 16px;\n\n\t--background: var(--background-default);\n}\n\n// .page-shell {\n// \tmin-height: 100%;\n// \tbackground: radial-gradient(120% 120% at 50% -20%, #ffffff 0%, #f7f2e7 60%, #efe6cf 100%);\n// \tborder-radius: 18px;\n// \tpadding: 18px;\n// \tbox-shadow: inset 0 0 0 1px rgba(205, 165, 60, 0.2);\n// }\n\n.title {\n\twidth: 100%;\n\tfont-family: AppFontMedium;\n\tfont-size: 20px;\n\tline-height: 120%;\n\tletter-spacing: 0.02em;\n\tvertical-align: middle;\n\ttext-align: center;\n\ttext-transform: uppercase;\n\n\tcolor: var(--color-black);\n\tmargin-bottom: 16px;\n}\n\n.wrapper {\n\twidth: 100%;\n\tmax-width: 1000px;\n\tmargin: 0 auto;\n\theight: fit-content;\n\n\tdisplay: grid;\n\tgrid-template-columns: repeat(auto-fill, minmax(46%, 1fr));\n\tgap: 10px;\n\n\t.item {\n\t\tmin-height: 165px;\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\tpadding: 14px 12px;\n\t\tborder-radius: var(--radius-default);\n\t\tbackground: #ffffff;\n\t\tborder: 1px solid #f6ebde;\n\t\t\n\t\tcursor: pointer;\n\t\tposition: relative;\n\n\t\tion-img,\n\t\tion-icon {\n\t\t\theight: 90px;\n\t\t\tobject-fit: contain;\n\n\t\t\tmargin-bottom: 10px;\n\n\t\t\t&.default {\n\t\t\t\tpadding-inline: 16px;\n\t\t\t\t--icon-color: var(--color-black);\n\t\t\t\theight: 90px;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\n\t\t.name {\n\t\t\tfont-family: AppFontSemiBold;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 100%;\n\t\t\ttext-align: center;\n\t\t\ttext-transform: uppercase;\n\n\t\t\tcolor: var(--ion-color-tertiary);\n\t\t}\n\n\t\t.info {\n\t\t\tmargin: 0;\n\t\t\tflex: 1;\n\t\t\tword-break: break-word;\n\t\t\tdisplay: -webkit-box;\n\t\t\t-webkit-line-clamp: 2;\n\t\t\t-webkit-box-orient: vertical;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\n\t\t\tfont-family: AppFontMedium;\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 110%;\n\t\t\tletter-spacing: 0;\n\t\t\tvertical-align: middle;\n\n\t\t\tcolor: var(--color-black);\n\t\t\tmargin-top: 6px;\n\t\t}\n\t}\n}\n\n.spinner-wrapper {\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
